import React from 'react';
import { Steps } from 'antd';
import cx from 'classnames';

import {
  ERROR_STEP_ICON,
  getStageNumber,
  getImportStepIcon,
} from 'utils/trackerUtils';
import { StepValidationStatuses } from 'enums';

import styles from './BaseBulkIMportStep.module.less';

const { Step } = Steps;


export interface BulkImportStagesModel {
  status: StepValidationStatuses;
  stepIndex: number;
  prefixCls: string;
  iconPrefix: string;
  title: string;
}

type Props = {
  stage: BulkImportStagesModel;
  index: number;
};

export default React.memo((props: Props) => {
  const { stage, index } = props;
  const { title, ...restProps } = stage;
  const stepIcon = getImportStepIcon(stage.status);

  return (
    <Step
      key={index}
      icon={<span className={cx('icon', stepIcon)} />}
      title={
        <div>
          <div>{getStageNumber(index)}</div>
          <div className={styles.title}>{title}</div>
        </div>
      }
      className={cx({
        'is-error': stepIcon === ERROR_STEP_ICON,
      })}
      {...restProps}
    />
  );
});
